module.exports = __webpack_public_path__ + "img/lb6.250c3cee.svg";